import { useEffect } from "react";
import { SwiperCarousel } from "../../components/swiperCarousel";
import { AtaxxScreen } from "./AtaxxScreen";
import { TapFastScreen } from "./TapFastScreen";
import { WordSort } from "./WordSort";

export const Games = ({ handleBackgroundChange }: any) => {
  useEffect(() => {
    handleBackgroundChange(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  const dataForSwiper = [
    { game: "ataxx", component: <AtaxxScreen /> },
    { game: "tapfast", component: <TapFastScreen /> },
    { game: "wordsort", component: <WordSort /> },
  ];

  return (
    <div className="flex z-10 flex-1 gap-4 sm:gap-4 md:gap-4 lg:gap-24 h-full w-full overflow-hidden">
      <SwiperCarousel
        data={dataForSwiper}
        onSlideChange={handleBackgroundChange}
      />
    </div>
  );
};
